exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/node_modules/postcss-loader?{"ident":"postcss"}!/home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles